import { Mail, MessageCircle } from "lucide-react";
import { PublicInfoLayout } from "./PublicInfoLayout";

const SUPPORT_EMAIL = "kirubeezy1@gmail.com";
const WHATSAPP_NUMBER = "917208873079";
const SUPPORT_MESSAGE =
  "Hi Kirubeezy Studios, I need help with the mixing masterclass.";

// const EMAIL_URL = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
//   "Kirubeezy Studios support request"
// )}&body=${encodeURIComponent(SUPPORT_MESSAGE)}`;

const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  SUPPORT_MESSAGE
)}`;

export default function Contact() {
  return (
    <PublicInfoLayout eyebrow="Contact" title="Get support">
      <div className="grid gap-6 md:grid-cols-2">
        <section className="flex h-full flex-col rounded-lg border border-white/[0.08] bg-white/[0.03] p-6 md:p-8">
          <div className="w-12 h-12 rounded-lg bg-[#C5A059]/10 border border-[#C5A059]/30 flex items-center justify-center">
            <Mail className="w-6 h-6 text-[#C5A059]" strokeWidth={1.8} />
          </div>

          <div className="mt-6 flex-1">
            <h2 className="font-heading text-2xl font-semibold tracking-tight text-white">
              Email support
            </h2>
            <p className="mt-3 text-zinc-400">
              Best for billing, account access, subscriptions, and detailed
              course questions.
            </p>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="mt-5 inline-flex text-sm font-medium text-[#E5BE6B] hover:text-white transition-colors"
            >
              {SUPPORT_EMAIL}
            </a>
          </div>

          {/* <a
            href={EMAIL_URL}
            className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-[#C5A059] px-6 py-3 text-sm font-semibold text-black transition-all hover:bg-[#E5BE6B] active:scale-[0.98]"
          >
            Send Email
            <Mail className="w-4 h-4" strokeWidth={1.9} />
          </a> */}
        </section>

        <section className="flex h-full flex-col rounded-lg border border-white/[0.08] bg-white/[0.03] p-6 md:p-8">
          <div className="w-12 h-12 rounded-lg bg-[#25D366]/10 border border-[#25D366]/30 flex items-center justify-center">
            <MessageCircle className="w-6 h-6 text-[#25D366]" strokeWidth={1.8} />
          </div>

          <div className="mt-6 flex-1">
            <h2 className="font-heading text-2xl font-semibold tracking-tight text-white">
              WhatsApp chat
            </h2>
            <p className="mt-3 text-zinc-400">
              Best for quick questions and faster back-and-forth support from
              your phone.
            </p>
            <p className="mt-5 text-sm font-medium text-[#E5BE6B]">
              +{WHATSAPP_NUMBER}
            </p>
          </div>

          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            className="mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-semibold text-black transition-all hover:bg-[#36E377] active:scale-[0.98]"
          >
            Open WhatsApp
            <MessageCircle className="w-4 h-4" strokeWidth={1.9} />
          </a>
        </section>
      </div>
    </PublicInfoLayout>
  );
}
